import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {ACTION_USER_LOGGED_IN, ACTION_USER_LOGGING_IN, ACTION_USER_LOGGING_IN_ERROR, PATH_LOGIN, PATH_USER_INFO, API_KEY_WEBPORTAL} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  return Observable.of({
    type: ACTION_USER_LOGGING_IN_ERROR,
    payload: data
  })
}

const loginEpic = action$ =>
  action$.ofType(ACTION_USER_LOGGING_IN)
    .mergeMap(action => {

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_LOGIN}`,
        headers: {
          'NEEURO-API-KEY': API_KEY_WEBPORTAL
        },
        body: action.payload,
        responseType: 'json'
      }).mergeMap(data=> {

        const tokenData = data.response

        const token = tokenData.access_token
        const type = tokenData.token_type

        return ajax({
          method: 'GET',
          url: `${api_server_host}${PATH_USER_INFO}`,
          headers: {
            Authorization: `${type} ${token}`
          },
          responseType: 'json'
        }).map(data=> {
          const userInfo = data.response
          const {name, profileImagePath, dob, id, emailAddress, country, city, education, occupation, isMale, userType} = userInfo
          return {
            type: ACTION_USER_LOGGED_IN, payload: {
              ...tokenData,
              name,
              profileImagePath,
              dob,
              id,
              emailAddress,
              country,
              city,
              education,
              occupation,
              isMale,
              userType
            }
          }
        }).catch(errorHandler)
      }).catch(errorHandler)
    })

export default loginEpic



// WEBPACK FOOTER //
// ./src/epics/LoginEpic.js